"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withNotificationContext = exports.useNotificationContext = exports.NotificationContextProvider = exports.NotificationContext = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _notistack = require("notistack");

var _material = require("@mui/material");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var NotificationContext = /*#__PURE__*/(0, _react.createContext)();
exports.NotificationContext = NotificationContext;
var DismissButton = (0, _styledComponents.default)(_material.Button)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.color.white;
});

var NotificationContextProvider = function NotificationContextProvider(_ref2) {
  var maxSnack = _ref2.maxSnack,
      withIcon = _ref2.withIcon,
      anchor = _ref2.anchor,
      children = _ref2.children,
      sx = _ref2.sx;

  var providerRef = _react.default.useRef(); // create action buttons


  var createActions = function createActions(key, actions, options) {
    var withDismiss = options.withDismiss,
        _options$dismissLabel = options.dismissLabel,
        dismissLabel = _options$dismissLabel === void 0 ? 'OK' : _options$dismissLabel;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, actions.map(function (_ref3) {
      var label = _ref3.label,
          handler = _ref3.handler;
      return /*#__PURE__*/_react.default.createElement(_material.Button, {
        onClick: handler
      }, label);
    }), withDismiss && /*#__PURE__*/_react.default.createElement(DismissButton, {
      onClick: function onClick() {
        return providerRef.current.closeSnackbar(key);
      }
    }, dismissLabel));
  };

  var displayNotification = function displayNotification() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var snackbarActions = function snackbarActions(key) {
      return createActions(key, actions, options);
    };

    var hasActions = actions.length !== 0;
    var notifOptions = {
      action: snackbarActions,
      variant: options.variant,
      anchorOrigin: options.position,
      autoHideDuration: options.autoHideDuration || 5000,
      persist: hasActions || options.withDismiss || options.persist,
      preventDuplicate: true
    };
    providerRef.current.enqueueSnackbar(message, notifOptions);
  };

  return /*#__PURE__*/_react.default.createElement(_notistack.SnackbarProvider, {
    ref: providerRef,
    maxSnack: maxSnack,
    hideIconVariant: !withIcon,
    domRoot: anchor,
    sx: (0, _objectSpread2.default)({
      '& .SnackbarItem-contentRoot': {
        'background-color': function backgroundColor(theme) {
          return theme.palette.success.main;
        },
        color: function color(theme) {
          return theme.palette.color.white;
        }
      },
      '& .SnackbarItem-variantSuccess': {
        'background-color': function backgroundColor(theme) {
          return theme.palette.success.main;
        },
        color: function color(theme) {
          return theme.palette.color.white;
        }
      },
      '& .SnackbarItem-variantInfo': {
        'background-color': function backgroundColor(theme) {
          return theme.palette.info.main;
        },
        color: function color(theme) {
          return theme.palette.secondary.main;
        }
      },
      '& .SnackbarItem-variantWarning': {
        'background-color': function backgroundColor(theme) {
          return theme.palette.warning.main;
        },
        color: function color(theme) {
          return theme.palette.color.white;
        }
      },
      '& .SnackbarItem-variantError': {
        'background-color': function backgroundColor(theme) {
          return theme.palette.error.main;
        },
        color: function color(theme) {
          return theme.palette.color.white;
        }
      }
    }, sx)
  }, /*#__PURE__*/_react.default.createElement(NotificationContext.Provider, {
    value: {
      displayNotification: displayNotification
    }
  }, children));
};

exports.NotificationContextProvider = NotificationContextProvider;
NotificationContextProvider.defaultProps = {
  anchor: null,
  maxSnack: 3,
  withIcon: true,
  sx: null
};

var useNotificationContext = function useNotificationContext() {
  return (0, _react.useContext)(NotificationContext);
}; // For class components


exports.useNotificationContext = useNotificationContext;

var withNotificationContext = function withNotificationContext(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(NotificationContext.Consumer, null, function (state) {
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, props, state));
    });
  };
};

exports.withNotificationContext = withNotificationContext;